<script setup>
import { useI18n } from "vue-i18n";
const { t } = useI18n();
</script>
<template>
  <div class="bg-white py-16">
    <div class="max-w-7xl mx-auto px-4">
      <!-- Section Title -->
      <h2 class="text-4xl md:text-5xl text-center mb-12">{{ t("Kwaliteit en borging") }}</h2>
      <div class="grid grid-cols-1 md:grid-cols-3 gap-8 items-center text-center md:text-left">
        <!-- Left Column -->
        <div class="space-y-12">
          <div>
            <h3 class="text-lg md:text-xl font-bold mb-2">{{ t("Screening") }}</h3>
            <p
              class="text-gray-700"
            >{{ t("Uitgebreide controle van kwalificaties en referenties voordat professionals worden toegelaten.") }}</p>
          </div>
          <div>
            <h3 class="text-lg md:text-xl font-bold mb-2">{{ t("Evaluatie") }}</h3>
            <p
              class="text-gray-700"
            >{{ t("Tevredenheidsscore van 9,1 volgens ZorgMonitor (Q1 2025) bevestigt onze kwaliteitsstandaard.") }}</p>
          </div>
        </div>
        <!-- Center Icon Graphic (You can replace this image with your own) -->
        <div class="flex justify-center">
          <img src="@/../img/home/center-graphic.png" alt="Visual graphic" class="w-full h-auto" />
        </div>
        <!-- Right Column -->
        <div class="space-y-12">
          <div>
            <h3 class="text-lg md:text-xl font-bold mb-2">{{ t("Educatie") }}</h3>
            <p
              class="text-gray-700"
            >{{ t("Permanente bijscholing en verplichte Verklaring Omtrent Gedrag voor alle aangesloten professionals.") }}</p>
          </div>
          <div>
            <h3 class="text-lg md:text-xl font-bold mb-2">{{ t("Ondersteuning") }}</h3>
            <p
              class="text-gray-700"
            >{{ t("Bereikbare helpdesk bij calamiteiten of vragen over de geleverde diensten.") }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>